import { useState } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";
import { login as apiLogin /*, register as apiRegister */ } from "../api.js";
import { useAuth } from "../context/AuthContext.jsx";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  // Registration is temporarily disabled — login-only mode.
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    // name: "",
    email: "",
    // companyName: "",
    password: "",
  });

  function set(field) {
    return (e) => setForm((f) => ({ ...f, [field]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      // const fn = mode === "login" ? apiLogin : apiRegister;
      // const payload =
      //   mode === "login"
      //     ? { email: form.email, password: form.password }
      //     : { name: form.name, email: form.email, companyName: form.companyName, password: form.password };
      const data = await apiLogin({ email: form.email, password: form.password });
      login(data.token, data.user);
      navigate("/profile");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={8} lg={5}>
          <Card className="shadow-sm border-0">
            <Card.Body className="p-4">
              <h2 className="mb-1 fw-bold text-primary">Sign In</h2>
              <p className="text-muted mb-4">
                New account registration is currently unavailable and will be
                offered at a later time. Please sign in with an existing account.
              </p>

              {/*
                Registration is temporarily disabled. The "Create Account" flow
                and its toggle have been commented out and will be restored later.
              */}

              {error && <Alert variant="danger">{error}</Alert>}

              <Form onSubmit={handleSubmit}>
                {/*
                {mode === "register" && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Jane Smith"
                        value={form.name}
                        onChange={set("name")}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Company Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Acme Medical"
                        value={form.companyName}
                        onChange={set("companyName")}
                        required
                      />
                    </Form.Group>
                  </>
                )}
                */}

                <Form.Group className="mb-3">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="you@example.com"
                    value={form.email}
                    onChange={set("email")}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder=""
                    value={form.password}
                    onChange={set("password")}
                    required
                  />
                </Form.Group>

                <Button type="submit" variant="primary" className="w-100" disabled={submitting}>
                  {submitting ? (
                    <Spinner animation="border" size="sm" className="me-2" />
                  ) : null}
                  Sign In
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
